import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

/**
 * constantRoutes: все маршруты приложения
 */
export const constantRoutes = [
  { path: "/", redirect: "/publication/list", hidden: true },
  {
    path: "/login",
    component: () => import("@/views/Login.vue"),
    meta: { title: "Вход", noAuth: true },
    hidden: true,
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true,
  },
  {
    path: "/digest",
    component: Layout,
    meta: { title: "Дайджесты", roles: ["admin", "editor"] },
    redirect: "/digest/list",
    children: [
      {
        path: "list",
        component: () => import("@/views/table/Digest.vue"),
        meta: {
          title: "Дайджесты",
          activeMenuParent: true,
          breadcrumb: false,
        },
        hidden: true,
      },
      {
        path: "create",
        component: () => import("@/views/form/Digest.vue"),
        meta: { title: "Создать дайджест", activeMenuParent: true },
        hidden: true,
      },
      {
        path: "edit/:id",
        component: () => import("@/views/form/Digest.vue"),
        meta: { title: "Редактировать дайджест", activeMenuParent: true },
        hidden: true,
      },
    ],
  },
  {
    path: "/site-section",
    component: Layout,
    meta: { title: "Разделы", roles: ["admin", "editor"] },
    redirect: "/site-section/list",
    children: [
      {
        path: "list",
        component: () => import("@/views/table/SiteSection.vue"),
        meta: {
          title: "Разделы",
          activeMenuParent: true,
          breadcrumb: false,
        },
        hidden: true,
      },
      {
        path: "create",
        component: () => import("@/views/form/SiteSection.vue"),
        meta: { title: "Создать раздел", activeMenuParent: true },
        hidden: true,
      },
      {
        path: "edit/:id",
        component: () => import("@/views/form/SiteSection.vue"),
        meta: { title: "Редактировать раздел", activeMenuParent: true },
        hidden: true,
      },
    ],
  },
  {
    path: "/publication",
    component: Layout,
    meta: { title: "Публикации", roles: ["admin", "editor"] },
    redirect: "/publication/list",
    children: [
      {
        path: "list",
        component: () => import("@/views/table/Publication.vue"),
        meta: {
          title: "Публикации",
          activeMenuParent: true,
          breadcrumb: false,
        },
        hidden: true,
      },
      {
        path: "create",
        component: () => import("@/views/form/Publication.vue"),
        meta: { title: "Создать публикацию", activeMenuParent: true },
        hidden: true,
      },
      {
        path: "edit/:id",
        component: () => import("@/views/form/Publication.vue"),
        meta: { title: "Редактировать публикацию", activeMenuParent: true },
        hidden: true,
      },
    ],
  },
  {
    path: "/main-banner",
    component: Layout,
    meta: { title: "Баннер", roles: ["admin", "editor"] },
    children: [
      {
        path: "edit",
        component: () => import("@/views/form/MainBanner.vue"),
        meta: { title: "Баннер" },
      },
    ],
  },
  {
    path: "/users",
    component: Layout,
    meta: { title: "Пользователи", roles: ["admin"] },
    redirect: "/users/list",
    children: [
      {
        path: "list",
        component: () => import("@/views/table/Users.vue"),
        meta: {
          title: "Пользователи",
          activeMenuParent: true,
          breadcrumb: false,
        },
        hidden: true,
      },
      {
        path: "create",
        component: () => import("@/views/form/User.vue"),
        meta: { title: "Создать пользователя", activeMenuParent: true },
        hidden: true,
      },
      {
        path: "edit/:id",
        component: () => import("@/views/form/User.vue"),
        meta: { title: "Редактировать пользователя", activeMenuParent: true },
        hidden: true,
      },
    ],
  },
  { path: "*", redirect: "/404", hidden: true },
];

// динамические маршруты не используем
export const asyncRoutes = [];

const createRouter = () =>
  new Router({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export default router;
